module.exports = __webpack_public_path__ + "img/Артроз пальцев и кисти.c5e4f2a7.jpg";